// wasteDisposalForm/wasteInfo/actions.js

export const makeWasteDisposalFormWasteInfoActions = ({
  setWasteDisposalUi,
  bump,
  emitWdPatch,
}) => ({
  // Waste Disposal Name of Waste and Process Generating
  updateWdNameOfWaste(wdData, nameOfWaste, emitPatch) {
    wdData.basicInfo.updateTextAttribute("nameOfWaste", nameOfWaste);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ nameOfWaste });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdProcessGenerating(wdData, processGenerating, emitPatch) {
    wdData.basicInfo.updateTextAttribute(
      "processGenerating",
      processGenerating
    );
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ processGenerating });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  // Container Table Methods
  addWasteDisposalContainerTableRow(wdData, emitPatch) {
    wdData.addContainerInfo();
    // Get the newly added container (last one in the array)
    const newContainer = wdData.containerInfo[wdData.containerInfo.length - 1];
    if (emitPatch) {
      const patch = newContainer.toPatch({}, "add", wdData.basicInfo.id);
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  removeWasteDisposalContainerTableRow(wdData, rowId, emitPatch) {
    // Get the container before removing to build patch
    const containerToRemove = wdData.containerInfo.find(
      (c) => c.rowId === rowId
    );
    if (emitPatch && containerToRemove) {
      const patch = containerToRemove.toPatch({}, "remove", wdData.basicInfo.id);
      emitWdPatch(patch, emitPatch);
    }
    wdData.removeContainerInfo(rowId);
    bump();
  },

  // Updating the data in specific rows
  updateWdContainer(wdData, value, rowId, emitPatch) {
    wdData.updateContainerInfo(rowId, "container", value);
    if (emitPatch) {
      const container = wdData.containerInfo.find((c) => c.rowId === rowId);
      if (container) {
        const patch = container.toPatch(
          { container: value },
          "update",
          wdData.basicInfo.id
        );
        emitWdPatch(patch, emitPatch);
      }
    }
    bump();
  },

  updateWdContainerAmount(wdData, value, rowId, emitPatch) {
    wdData.updateContainerInfo(rowId, "amount", value);
    if (emitPatch) {
      const container = wdData.containerInfo.find((c) => c.rowId === rowId);
      if (container) {
        const patch = container.toPatch(
          { amount: value },
          "update",
          wdData.basicInfo.id
        );
        emitWdPatch(patch, emitPatch);
      }
    }
    bump();
  },

  updateWdContainerWasteType(wdData, value, rowId, emitPatch) {
    wdData.updateContainerInfo(rowId, "wasteType", value);
    if (emitPatch) {
      const container = wdData.containerInfo.find((c) => c.rowId === rowId);
      if (container) {
        const patch = container.toPatch(
          { wasteType: value },
          "update",
          wdData.basicInfo.id
        );
        emitWdPatch(patch, emitPatch);
      }
    }
    bump();
  },

  // Waste Disposal Constituents Table Methods
  addWasteDisposalConstituentsTableRow(wdData, emitPatch) {
    wdData.addConstituent();
    // Get the newly added constituent (last one in the array)
    const newConstituent = wdData.constituents[wdData.constituents.length - 1];
    if (emitPatch) {
      const patch = newConstituent.toPatch({}, "add", wdData.basicInfo.id);
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  removeWasteDisposalConstituentsTableRow(wdData, rowId, emitPatch) {
    // Get the constituent before removing to build patch
    const constituentToRemove = wdData.constituents.find(
      (c) => c.rowId === rowId
    );
    if (emitPatch && constituentToRemove) {
      const patch = constituentToRemove.toPatch(
        {},
        "remove",
        wdData.basicInfo.id
      );
      emitWdPatch(patch, emitPatch);
    }
    wdData.removeConstituent(rowId);
    bump();
  },

  // Updating the data in specific rows
  updateWdConstituent(wdData, value, rowId, emitPatch) {
    wdData.updateConstituentInfo(rowId, "constituent", value);
    if (emitPatch) {
      const constituent = wdData.constituents.find((c) => c.rowId === rowId);
      if (constituent) {
        const patch = constituent.toPatch(
          { constituent: value },
          "update",
          wdData.basicInfo.id
        );
        emitWdPatch(patch, emitPatch);
      }
    }
    bump();
  },

  updateWdConstituentConcentrationRange(wdData, value, rowId, emitPatch) {
    wdData.updateConstituentInfo(rowId, "concentrationRange", value);
    if (emitPatch) {
      const constituent = wdData.constituents.find((c) => c.rowId === rowId);
      if (constituent) {
        const patch = constituent.toPatch(
          { concentrationRange: value },
          "update",
          wdData.basicInfo.id
        );
        emitWdPatch(patch, emitPatch);
      }
    }
    bump();
  },
});
